var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border rounded p-4 flex"},[_c('div',{staticClass:"flex-1"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('button',{on:{"click":_vm.closeNotification}},[_c('svg-x-circle-solid')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }